var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useBlocker, useLoaderData, useRevalidator } from 'react-router';
import { useSetAtom } from 'jotai';


import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { Translate } from "../../../../I18N";
import { notificationAtom, settingsAtom } from "../../../atoms";
import * as settingsAPI from "../../../api/settings";
import * as templatesAPI from "../../../api/templates";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, Table, ConfirmNavigationModal } from "../../../Components/UI";
import {
  createColumns,
  AddTemplatesModal,
  filterAvailableTemplates,
  createNewFilters,
  updateFilters,
  deleteFilters,
  FiltersSidepanel,
  sidepanelAtom,

  sanitizeFilters,
  formatFilters } from "./components";



const filtersLoader =
(headers) =>
async () => {
  const { filters } = await settingsAPI.get(headers);
  const templates = await templatesAPI.get(headers);
  const tableFilters = formatFilters(filters || []);
  return { filters: tableFilters, templates };
};

const FiltersTable = () => {
  const { filters: loadedFilters = [], templates: loadedTemplates } = useLoaderData();
  const currentFilters = useRef(loadedFilters);
  const [hasChanges, setHasChanges] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [confirmNavigationModal, setConfirmNavigationModal] = useState(false);
  const [showSidepanel, setShowSidepanel] = useState(false);
  const [filters, setFilters] = useState(loadedFilters);
  const [selectedFilters, setSelectedFilters] = useState({});
  const blocker = useBlocker(hasChanges);
  const setAtom = useSetAtom(sidepanelAtom);
  const setNotifications = useSetAtom(notificationAtom);
  const setSettings = useSetAtom(settingsAtom);
  const revalidator = useRevalidator();

  const templates = useMemo(
    () => filterAvailableTemplates(loadedTemplates, filters),
    [filters, loadedTemplates]
  );

  useEffect(() => {
    const formattedFilters = formatFilters(loadedFilters || []);
    currentFilters.current = formattedFilters;
    setFilters(formattedFilters);
  }, [loadedFilters]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setConfirmNavigationModal(true);
    }
  }, [blocker, setConfirmNavigationModal]);

  const cancel = () => {
    currentFilters.current = loadedFilters;
    setFilters(loadedFilters);
    setHasChanges(false);
  };

  const addNewFilters = (templatedIds) => {
    const newFilters = createNewFilters(templatedIds, templates);
    setFilters([...currentFilters.current, ...newFilters]);
  };

  const handleDelete = () => {var _currentFilters$curre;
    const idsToRemove = [];
    (_currentFilters$curre = currentFilters.current) === null || _currentFilters$curre === void 0 ? void 0 : _currentFilters$curre.forEach((filter) => {
      if (filter.rowId in selectedFilters) {
        idsToRemove.push(filter.rowId);
      }
      if (filter.subRows) {
        filter.subRows.forEach((subRow) => {
          if (subRow.rowId in selectedFilters) {
            idsToRemove.push(subRow.rowId);
          }
        });
      }
    });

    const updatedFilters = deleteFilters(currentFilters.current, idsToRemove);
    setFilters(updatedFilters || []);
  };

  const handleSave = async () => {
    setDisabled(true);
    const filtersToSave = sanitizeFilters(currentFilters.current);
    const response = await settingsAPI.save({ filters: filtersToSave });
    if (response instanceof FetchResponseError) {
      return setNotifications(_objectSpread({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred") },
      response.message && { details: response.message })
      );
    }
    setSettings(response);
    setDisabled(false);
    setHasChanges(false);
    await revalidator.revalidate();
    return setNotifications({ type: 'success', text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Filters saved") });
  };

  const handleChange = ({
    rows,
    selectedRows



  }) => {
    currentFilters.current = rows;
    setSelectedFilters(selectedRows);
    if (JSON.stringify(currentFilters.current) !== JSON.stringify(loadedFilters)) {
      setHasChanges(true);
    } else {
      setHasChanges(false);
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "h-full w-full overflow-y-auto" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Filters" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "p-4 mb-4 rounded-md border border-gray-50 shadow-sm bg-primary-100 text-primary-700" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center w-full text-base font-semibold" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-5 h-5" }, void 0, /*#__PURE__*/
    _jsx(CheckCircleIcon, {})
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Filters configuration")
    ), /*#__PURE__*/
    _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Filters configuration description" }, void 0, "By default, users can filter the entities in the library based on the types you have defined. However, you can configure how these entity types will be displayed:"


    ), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx("ul", { className: "list-disc list-inside" }, void 0, /*#__PURE__*/
    _jsx("li", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Filters configuration" }, void 0, "drag and drop each entity type into the window in order to configure their order"

    )
    ), /*#__PURE__*/
    _jsx("li", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Filters configuration example" }, void 0, "Select \"Add group\" below to group filters under a label e.g (\"Documents \"or \"People\")"


    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Table, {
      dnd: { enable: true },
      enableSelections: true,
      onChange: handleChange,
      columns: createColumns(setShowSidepanel),
      data: filters,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Filters"

      ) }

    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "flex flex-wrap gap-2 w-full md:justify-between md:gap-0" }, void 0,
    Object.keys(selectedFilters).length ? /*#__PURE__*/
    _jsx(Button, { styling: "solid", color: "error", onClick: () => handleDelete() }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete")
    ) : /*#__PURE__*/

    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 md:flex-wrap" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "solid", color: "primary", onClick: () => setShowModal(true) }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "text-nowrap" }, void 0, "Add entity type")
    ), /*#__PURE__*/
    _jsx(Button, {
      styling: "solid",
      color: "primary",
      onClick: () => {
        setShowSidepanel(true);
        setAtom(undefined);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "text-nowrap" }, void 0, "Add group")
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 md:flex-wrap" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "outline",
      color: "primary",
      onClick: () => cancel(),
      disabled: !hasChanges || disabled }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      styling: "solid",
      color: "success",
      onClick: async () => handleSave(),
      disabled: !hasChanges || disabled }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )

    )
    ),
    showModal && /*#__PURE__*/
    _jsx(AddTemplatesModal, {
      templates: templates,
      onCancel: () => setShowModal(false),
      onAdd: (templateIds) => addNewFilters(templateIds) }
    ),

    confirmNavigationModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, {
      setShowModal: setConfirmNavigationModal,
      onConfirm: async () => {
        if (blocker.proceed) {
          blocker.proceed();
        }
      } }
    ), /*#__PURE__*/

    _jsx(FiltersSidepanel, {
      showSidepanel: showSidepanel,
      setShowSidepanel: setShowSidepanel,
      onSave: (newFilter) => {
        if (newFilter) {
          setFilters(updateFilters(newFilter, filters) || []);
        }
      },
      availableTemplates: templates }
    )
    ));

};

export { FiltersTable, filtersLoader };